import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { Installmentchange } from "./installmentchange.model";

@Injectable({
  providedIn: 'root'
})

export class InstallmentchangeService {

  constructor(private httpClient: HttpClient) { }

  
  public selectedInstallmentchange: Installmentchange;
  public InstallmentchangeList: Installmentchange[];
  public installmentchange: Installmentchange;

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDInstallmentChange(installmentchange:Installmentchange){

    installmentchange.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    installmentchange.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    installmentchange.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    installmentchange.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = installmentchange;
    
    console.log(body);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/InstallmentChange/IUD', body, { headers: headers });
  
    }

  FetchInstallmentChangeById(installmentchange) {

    installmentchange.Id = + installmentchange.Id;
    installmentchange.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    installmentchange.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    installmentchange.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    installmentchange.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = installmentchange;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/InstallmentChange/Fetch', body, { headers: headers });
  }


  FetchInstallmentChangeList(){
    
    this.installmentchange = new Installmentchange();
    this.installmentchange.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.installmentchange.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.installmentchange.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.installmentchange.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.installmentchange;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/InstallmentChange/FetchList', body, { headers: headers });
  }

}
